import { resumeDateDisplay } from '@/lib/dates/dateHelper'

const formatDate = (date, endDate = false) => {
  return resumeDateDisplay(date, endDate)
}

export default formatDate
